import styled from "styled-components";

export const Container = styled.div`
    margin: 0.2rem 0.5rem 0.2rem 4.5rem;
    position: relative;
`
